<div class="form-container">
    <h2>Create Fuel Option</h2>
  
    <form [formGroup]="fuelOptionForm" (ngSubmit)="createFuelOption()">
       <div class="form-group">
        <label for="ScenarioCategoryId">Scenario Category:</label>
        <select class="form-control" formControlName="ScenarioCategoryId" id="ScenarioCategoryId">
          <option value="">Select Category</option>
          <option *ngFor="let category of categories" [value]="category.id">{{ category.title }}</option>
        </select>
        <div *ngIf="errors.ScenarioCategoryId" class="text-danger">
          <ul>
            <li *ngFor="let error of errors.ScenarioCategoryId">{{ error }}</li>
          </ul>
        </div>
      </div>
      <div class="form-group">
        <label>Fuel Name:</label>
        <input type="text" class="form-control" formControlName="title" placeholder="Fuel Name">
        <div *ngIf="errors.title" class="text-danger">
          <ul>
            <li *ngFor="let error of errors.title">{{ error }}</li>
          </ul>
        </div>
      </div>
  
      <div class="form-group">
        <label>Coefficient:</label>
        <input type="number" class="form-control" formControlName="coefficient" placeholder="Coefficient">
        <div *ngIf="errors.coefficient" class="text-danger">
          <ul>
            <li *ngFor="let error of errors.coefficient">{{ error }}</li>
          </ul>
        </div>
      </div>
  
      <div class="form-group">
        <label>Percentage:</label>
        <input type="number" class="form-control" formControlName="percentage" placeholder="Percentage">
        <div *ngIf="errors.percentage" class="text-danger">
          <ul>
            <li *ngFor="let error of errors.percentage">{{ error }}</li>
          </ul>
        </div>
      </div>

      <div class="form-group">
        <label>Description:</label>
        <textarea class="form-control" formControlName="description" placeholder="Optional description..." rows="3">
                        </textarea>
        <div *ngIf="errors.description" class="text-danger">
          <ul>
            <li *ngFor="let error of errors.description">{{ error }}</li>
          </ul>
        </div>
      </div>
  
     
      <div *ngIf="errors.general" class="text-danger">
        <ul>
          <li *ngFor="let error of errors.general">{{ error }}</li>
        </ul>
      </div>
      <button type="submit" class="btn btn-primary" >
        {{ isSubmitting ? 'Submitting...' : 'Create Fuel Option' }}
      </button>
      
    </form>
    
  </div>
  